var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIconmainactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2518 21.0038C11.2182 21.0038 12.0017 20.2203 12.0017 19.2539C12.0017 18.2874 11.2182 17.5039 10.2518 17.5039C9.2853 17.5039 8.50183 18.2874 8.50183 19.2539C8.50183 20.2203 9.2853 21.0038 10.2518 21.0038Z",
    fill: "#5070DE",
    stroke: "#5070DE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8759 21.0038C18.8424 21.0038 19.6258 20.2203 19.6258 19.2539C19.6258 18.2874 18.8424 17.5039 17.8759 17.5039C16.9094 17.5039 16.126 18.2874 16.126 19.2539C16.126 20.2203 16.9094 21.0038 17.8759 21.0038Z",
    fill: "#5070DE",
    stroke: "#5070DE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19533 5.37134L8.26314 11.9185C8.58103 12.9246 8.73946 13.4277 9.045 13.8001C9.31248 14.1294 9.66122 14.3835 10.0552 14.5409C10.5028 14.7188 11.0295 14.7188 12.085 14.7188H16.0509C17.1064 14.7188 17.6331 14.7188 18.0796 14.5409C18.4746 14.3835 18.8223 14.1294 19.0908 13.8001C19.3954 13.4277 19.5538 12.9246 19.8727 11.9185L20.2935 10.5852L20.5404 9.79716L20.8809 8.71694C21.0024 8.33166 21.0315 7.92317 20.9657 7.52458C20.8999 7.12598 20.7412 6.74848 20.5023 6.42266C20.2635 6.09685 19.9513 5.83188 19.5909 5.64923C19.2306 5.46658 18.8323 5.37137 18.4283 5.37134H6.19533ZM6.19533 5.37134L6.18401 5.33328C6.14057 5.18776 6.09254 5.04366 6.03999 4.90119C5.83171 4.37398 5.47853 3.91646 5.02123 3.58149C4.56394 3.24653 4.02121 3.04778 3.45574 3.00823C3.34978 3 3.23353 3 3 3",
    fill: "#5070DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19533 5.37134L8.26314 11.9185C8.58103 12.9246 8.73946 13.4277 9.045 13.8001C9.31248 14.1294 9.66122 14.3835 10.0552 14.5409C10.5028 14.7188 11.0295 14.7188 12.085 14.7188H16.0509C17.1064 14.7188 17.6331 14.7188 18.0796 14.5409C18.4746 14.3835 18.8223 14.1294 19.0908 13.8001C19.3954 13.4277 19.5538 12.9246 19.8727 11.9185L20.2935 10.5852L20.5404 9.79716L20.8809 8.71694C21.0024 8.33166 21.0315 7.92317 20.9657 7.52458C20.8999 7.12598 20.7412 6.74848 20.5023 6.42266C20.2635 6.09685 19.9513 5.83188 19.5909 5.64923C19.2306 5.46658 18.8323 5.37137 18.4283 5.37134H6.19533ZM6.19533 5.37134L6.18401 5.33328C6.14057 5.18776 6.09254 5.04366 6.03999 4.90119C5.83171 4.37398 5.47853 3.91646 5.02123 3.58149C4.56394 3.24653 4.02121 3.04778 3.45574 3.00823C3.34978 3 3.23353 3 3 3",
    stroke: "#5070DE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconmainactive);
export default __webpack_public_path__ + "static/media/cartIconmainactive.7a3a01899958ae126a3aced6363abb16.svg";
export { ForwardRef as ReactComponent };